export default "__VITE_ASSET__BJIY5CLO__"